// [ / ] cycling for the Orderbook/Trades sub-tab, gated to the hovered panel.
// Only the TAB layout has the toggle (STACKED/LARGE show both), so pass a count
// of 0 in other layouts to make the shortcut inert there. Returns the ref to
// attach to the panel container.
import { RefObject } from "react";
import { useTabCycle } from "keyboard/useTabCycle";
import { OrderbookLayoutEnum } from "./shared";
import { OrderbookTradeHistoryType } from "./types";

const OB_TABS = [
  OrderbookTradeHistoryType.ORDERBOOK,
  OrderbookTradeHistoryType.TRADES,
];

export function useOrderbookTabsKeyboard(
  layout: OrderbookLayoutEnum,
  current: OrderbookTradeHistoryType,
  setCurrent: (tab: OrderbookTradeHistoryType) => void,
): RefObject<HTMLDivElement> {
  return useTabCycle<HTMLDivElement>(
    layout === OrderbookLayoutEnum.TAB ? OB_TABS.length : 0,
    OB_TABS.indexOf(current),
    (i) => setCurrent(OB_TABS[i]),
    { gated: true },
  );
}
